import { render, staticRenderFns } from "./ExperimentDetails.vue?vue&type=template&id=1f4d23b6&"
import script from "./ExperimentDetails.vue?vue&type=script&lang=js&"
export * from "./ExperimentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports